<template>
	<q-layout :view="getView">
		<etraining-header />

		<menu-left />

		<q-page-container>
			<etraining-navbar />

             <accept-terms/>

			<router-view />
		</q-page-container>

		<etraining-footer />
	</q-layout>
</template>

<script>
import Header from 'components/admin/Header.vue'
import Footer from 'components/admin/Footer'
import Navbar from 'components/admin/Navbar'
import MenuLeft from 'components/admin/MenuLeft.vue'
import AcceptTerms from 'components/authenticated/AcceptTerms'
import { mapGetters } from 'vuex'
import { colors } from 'quasar'

export default {
	components: {
		'etraining-header': Header,
		'etraining-footer': Footer,
		'etraining-navbar': Navbar,
        'menu-left': MenuLeft,
        'accept-terms': AcceptTerms,
	},

	computed: {
		...mapGetters({
			clients: 'params/clients',
			params_loaded: 'params/params_loaded',
			id_user_client_selected: 'common/id_user_client_selected'
		}),

		getView() {
			if (this.$q.platform.is.mobile) return 'hHh Lpr lFf'
			else return 'hHh Lpr fff'
		}
	},

	methods: {
		changeColor() {
			let client = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })

			if (client) {
				colors.setBrand('primary', client.colors.primary)
				colors.setBrand('secondary', client.colors.secondary)
				colors.setBrand('tertiary', client.colors.tertiary)
			}
		}
	},

	watch: {
		params_loaded: function() {
			this.changeColor()
		},

		id_user_client_selected: function() {
			this.changeColor()
        }
	},

	mounted() {
		if (this.clients) {
			let client = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })

			if (client) {
				colors.setBrand('primary', client.colors.primary)
				colors.setBrand('secondary', client.colors.secondary)
				colors.setBrand('tertiary', client.colors.tertiary)
			}
		}
	}
}
</script>

<style>
</style>
